'use client'

import { Button } from '@qr-front/ui/components/Button'
import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogFooter,
	DialogTitle,
} from '@qr-front/ui/components/Dialog'
import { userSettingsApi } from 'api/userSettings'
import { useAtom, useSetAtom } from 'jotai'
import { useTranslations } from 'next-intl'

import { userAtom } from '@/global-state'

import { bannerDialogStateAtom } from './bannerStates'

export const BannerDialog = () => {
	const t = useTranslations()
	const [bannerDialogState, setBannerDialogState] = useAtom(
		bannerDialogStateAtom,
	)
	const setUser = useSetAtom(userAtom)

	if (!bannerDialogState) return null

	const handleOnSuccess = async () => {
		try {
			const response = await userSettingsApi.getUser()
			if (response.data) {
				setUser(response.data)
			}
		} catch (error) {
			console.warn('Failed to refresh user data:', error)
		}
		setBannerDialogState(null)
	}

	const onOpenChange = (open: boolean) => {
		setBannerDialogState(open ? bannerDialogState : null)

		// If the dialog is being closed, treat it as a success action
		if (!open) {
			handleOnSuccess()
		}
	}

	return (
		<Dialog open={!!bannerDialogState} onOpenChange={onOpenChange}>
			<DialogContent
				closeButtonLabel={t('ui__popup__close_button')}
				className="max-w-[350px] p-0 desktop:max-w-[500px]"
			>
				<div className="p-6 text-center desktop:p-8">
					<DialogTitle>{bannerDialogState.title}</DialogTitle>
					<DialogDescription className="mt-2 text-body-medium">
						{bannerDialogState.description}
					</DialogDescription>
					<DialogFooter className="mt-4 tablet:mt-6">
						<Button
							onClick={handleOnSuccess}
							className="mx-auto max-w-[120px] focus-visible:outline-none"
						>
							{bannerDialogState.actionLabel}
						</Button>
					</DialogFooter>
				</div>
			</DialogContent>
		</Dialog>
	)
}
